<div>
  <mode-accessor-search-input
    [disabled]="disabled"
    [placeholder]="'Search...'"
    (valueChanged)=valueChanged($event)
    (keyup.arrowup)="selectPreviousItem()"
    (keyup.arrowdown)="selectNextItem()"
    (keyup.enter)="addActiveItemToSelectedResults()"
  >
  <div *ngIf="(searchResults$| async) as results">
    <div
      *ngFor="let result of results"
      class="search-result"
      [ngClass]="{'is-active' : result.token === activeSearchResult?.token }"
      (click)="selectItem(result)"
    >
      <div class="avatar-icon-wrapper">
        <capra-avatar
          *ngIf="result.type === 'User'"
          type="user"
          size="small"
          [options]="result.avatar"
        ></capra-avatar>
        <mode-group-avatar
          *ngIf="result.type === 'UserGroup'"
        ></mode-group-avatar>
      </div>
      {{ result.name }}
    </div>
    <div *ngIf="!results.length" class="no-search-result">No matches found.</div>
  </div>
  </mode-accessor-search-input>
</div>
